import { useQueryClient } from '@tanstack/react-query';

import { useQueryKeys } from '@/shared/hooks/use-query-keys';

type InvalidateAllCampaignsOptions = {
  campaignId?: string;
  includeDetail?: boolean;
  includeMetrics?: boolean;
};

export function useInvalidateAllCampaigns() {
  const queryClient = useQueryClient();
  const queryKeys = useQueryKeys();

  return async ({
    campaignId,
    includeDetail = false,
    includeMetrics = false,
  }: InvalidateAllCampaignsOptions = {}) => {
    const invalidations = [
      queryClient.invalidateQueries({ queryKey: queryKeys.campaign.all() }),
    ];

    if (campaignId && includeDetail) {
      invalidations.push(
        queryClient.invalidateQueries({ queryKey: queryKeys.campaign.detail(campaignId) }),
        queryClient.invalidateQueries({ queryKey: queryKeys.campaign.overview(campaignId) }),
        queryClient.invalidateQueries({ queryKey: queryKeys.campaign.creatorsRoot(campaignId) }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.campaign.creatorCountsRoot(campaignId),
        }),
        queryClient.invalidateQueries({ queryKey: queryKeys.campaign.postsRoot(campaignId) }),
        queryClient.invalidateQueries({ queryKey: queryKeys.campaign.postCountsRoot(campaignId) }),
      );
    }

    if (campaignId && includeMetrics) {
      invalidations.push(
        queryClient.invalidateQueries({ queryKey: queryKeys.campaign.metrics(campaignId) }),
      );
    }

    await Promise.all(invalidations);
  };
}
